export const en = {
    'button-cancel': 'Cancel',
    'button-save': 'Save',
    'button-tree': 'Clusters',
    canel: 'Cancel',
    'cluster-navigation': 'Cluster structure\n',
    'create-subpage': 'Create subpage',
    'empty-description': 'You can be the first',
    'empty-title': 'There are no pages in the section',
    'error-become-not-accessible': 'You\'ll lose access to the page after moving it',
    'error-cluster-not-exists': 'The page you want to move doesn\'t exist.',
    'error-cluster-permissions': 'You don\'t have access to the subpages',
    'error-destination-reserved': 'Can\'t move page. The new URL is reserved.',
    'error-general': 'Couldn\'t move page. Please refresh the page and try again.',
    'error-into-self': 'Can\'t move page. It\'s already located at the specified URL.',
    'error-limit-exceeded': 'You can not do more than 100 page moves at the same time',
    'error-long-name': 'The new page URLs will be too long',
    'error-next-to-not-set': 'Can not move page into the same cluster',
    'error-override': 'Can\'t move page. Another page is located at that URL.',
    'error-source-reserved': 'Can\'t move a system page.',
    expand: 'Expand',
    'get-tree-error': 'Couldn\'t load data',
    'header-editing': 'Structure change',
    'header-moving': 'Loading...',
    'leave-unsaved-message': 'Are you sure you want to leave the page? Changes in navigation tree will not be saved.',
    'load-more': 'Show more',
    'move-success': 'Page moved',
    moving: 'Moving',
    'pages-move-message': 'Updating the cluster structure, this may take from a moment to several minutes...',
    'root-cluster-navigation': 'Wiki structure'
};
